import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { post } from 'data/services/config';

export type UpdateMultipleStatusParams = {
  phaseId: string;
  evaluationIds: string[];
  status: number | null;
};

const updateMultipleStatus = createAsyncThunk(
  'evaluations/updateMultipleStatus',
  async ({ phaseId, evaluationIds, status }: UpdateMultipleStatusParams, { rejectWithValue }) => {
    try {
      return await post(`/phases/${phaseId}/evaluations/update_multiple_status`, {
        evaluation_ids: evaluationIds,
        new_status: status,
      });
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

const initialState = {
  saving: false,
};

const evaluationsSlice = createSlice({
  name: 'evaluationsSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(updateMultipleStatus.pending, (state) => {
      state.saving = true;
    });
    builder.addCase(updateMultipleStatus.fulfilled, (state) => {
      state.saving = false;
    });
    builder.addCase(updateMultipleStatus.rejected, (state) => {
      state.saving = false;
    });
  },
  selectors: {
    getIsSaving: (state) => state.saving,
  },
});

export const fromEvaluations = evaluationsSlice.selectors;
export const evaluationsActions = { updateMultipleStatus };

export default evaluationsSlice.reducer;
